module.exports = __webpack_public_path__ + "media/images/logos/xpass-logo-dark-6fe3ebc0e9091dc44c60fee58f541710.svg";